export default "__VITE_ASSET__CCa4Nao$__"